export default function ServicePageHero({
  title,
  description,
  image,
}) {
  return (
    <section className="relative h-[500px] overflow-hidden">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center text-white">
        <h1 className="mb-4 text-4xl md:text-5xl font-bold">
          {title}
        </h1>

        <p className="max-w-2xl text-lg leading-relaxed">
          {description}
        </p>
      </div>
    </section>
  )
}